import { GenericServiceError } from '@dock/common';

// TODO: this function will be removed soon
export const handleErrors = (error: unknown): GenericServiceError<unknown> =>
    error as GenericServiceError<unknown>;
